
window.TwoLaneA11y = (function () {
  'use strict';

  var FOCUSABLE = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  function cssEscape(value) {
    var s = String(value);
    return (window.CSS && CSS.escape) ? CSS.escape(s) : s.replace(/["\\]/g, '\\$&');
  }

  function query(root, selector) {
    try {
      return root.querySelector(selector);
    } catch (e) {
      return null;
    }
  }

  function visible(el) {
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }

  function focusables(container) {
    return Array.prototype.filter.call(
      container.querySelectorAll(FOCUSABLE),
      function (el) { return visible(el) && !el.closest('[inert]'); }
    );
  }

  function trap(container, isOpen) {
    return function (e) {
      if (e.key !== 'Tab') return;
      if (typeof isOpen === 'function' && !isOpen()) return;

      var items = focusables(container);
      if (!items.length) return;

      var first = items[0];
      var last = items[items.length - 1];
      var active = document.activeElement;

      if (!container.contains(active)) {
        e.preventDefault();
        first.focus();
        return;
      }

      if (e.shiftKey && active === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && active === last) {
        e.preventDefault();
        first.focus();
      }
    };
  }

  function focusFirst(container, preferred) {
    var target = null;
    if (preferred) target = container.querySelector(preferred);
    if (!target || !visible(target)) target = focusables(container)[0];
    if (target) target.focus({ preventScroll: true });
  }

  function restore(el) {
    if (el && typeof el.focus === 'function' && document.contains(el)) {
      el.focus({ preventScroll: true });
    }
  }

  function captureFocus(container) {
    var active = document.activeElement;
    if (!active || !container.contains(active)) return null;
    var row = active;
    while (row && row.parentElement !== container) row = row.parentElement;
    return {
      selector: active.dataset && active.dataset.focusKey
        ? '[data-focus-key="' + cssEscape(active.dataset.focusKey) + '"]'
        : null,
      tag: active.tagName,
      cls: active.className,
      row: row ? Array.prototype.indexOf.call(container.children, row) : -1,
      rows: container.children.length
    };
  }

  function restoreFocus(container, snapshot) {
    if (!snapshot) return false;
    var el = snapshot.selector ? query(container, snapshot.selector) : null;
    var firstClass = typeof snapshot.cls === 'string' ? snapshot.cls.trim().split(/\s+/)[0] : '';
    var rows = container.children;

    if (!el && !snapshot.selector && firstClass && snapshot.row > -1 && rows.length === snapshot.rows) {
      var ownRow = rows[snapshot.row];
      el = ownRow ? query(ownRow, '.' + cssEscape(firstClass)) : null;
    }

    if (!el && snapshot.row > -1 && rows.length) {
      var neighbour = rows[Math.min(snapshot.row, rows.length - 1)];
      el = neighbour ? focusables(neighbour)[0] || null : null;
    }

    if (!el) return false;
    el.focus({ preventScroll: true });
    return true;
  }

  var lockCount = 0;
  var savedY = 0;

  function lockScroll() {
    if (lockCount++ > 0) return;
    savedY = window.scrollY || window.pageYOffset || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + savedY + 'px';
    document.body.style.width = '100%';
    document.body.classList.add('has-overlay');
  }

  function unlockScroll() {
    if (lockCount === 0) return;
    if (--lockCount > 0) return;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.classList.remove('has-overlay');
    var root = document.documentElement;
    var prevBehavior = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    window.scrollTo(0, savedY);
    root.style.scrollBehavior = prevBehavior;
  }

  return {
    trap: trap,
    lockScroll: lockScroll,
    unlockScroll: unlockScroll,
    focusFirst: focusFirst,
    restore: restore,
    focusables: focusables,
    captureFocus: captureFocus,
    restoreFocus: restoreFocus
  };
})();
